/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OsisRuleStateResponse
 */
export interface OsisRuleStateResponse {
    /**
     * 
     * @type {string}
     * @memberof OsisRuleStateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OsisRuleStateResponse
     */
    errorMessage?: string | null;
}

export function OsisRuleStateResponseFromJSON(json: any): OsisRuleStateResponse {
    return OsisRuleStateResponseFromJSONTyped(json, false);
}

export function OsisRuleStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function OsisRuleStateResponseToJSON(value?: OsisRuleStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


